import type { MembershipIncome } from '@fruitful/member-profile';

import { requestBuilder } from '../../http/RequestBuilder';

const useGetMembershipIncomes = requestBuilder.query<MembershipIncome[]>({
    endpoint: () => `/api/membership-income`,
    queryKey: () => `getMembershipIncomes`,
});

export default useGetMembershipIncomes;
